__turbopack_context__.v({
  "close-button": "ModalSeries-module-scss-module__hA04Yq__close-button",
  "contentShow": "ModalSeries-module-scss-module__hA04Yq__contentShow",
  "dialog-children": "ModalSeries-module-scss-module__hA04Yq__dialog-children",
  "dialog-content": "ModalSeries-module-scss-module__hA04Yq__dialog-content",
  "dialog-overlay": "ModalSeries-module-scss-module__hA04Yq__dialog-overlay",
  "dialog-title": "ModalSeries-module-scss-module__hA04Yq__dialog-title",
  "overlayShow": "ModalSeries-module-scss-module__hA04Yq__overlayShow",
});
